var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"iframe-container is-lazy",class:{ 'is-active': _vm.inViewport },style:({ computedHeight: _vm.hasAdaptiveHeight })},[_c('u-intersect',{attrs:{"root-margin":"0px 0px 250px 0px","once":true},on:{"enter":_vm.onEnter}},[_c('iframe',{ref:"iframe",staticClass:"iframe",style:({
        height: _vm.hasAdaptiveHeight ? `${_vm.iframeHeight}px` : false,
        width: _vm.hasAdaptiveHeight ? `100%` : false,
      }),attrs:{"src":_vm.inViewport ? _vm.src : 'data:,',"title":_vm.title}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }